const BASE_PATH = "app/shortlists/";

export const SET_SHORTLIST = `${BASE_PATH}set-shortlist`;
